import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MetadataCriteria, MetadataType } from '../common';

@Injectable({
  providedIn: 'root'
})
export class MetadataService {
  constructor(private http: HttpClient) { }

  async search(criteria?: MetadataCriteria) {
    return this.http.post<any[]>(environment.app.apiUrl + 'metadata/search', criteria || {}).toPromise();
  }

  async save(metadata: any) {
    return this.http.post(environment.app.apiUrl + 'metadata/save', metadata).toPromise();
  }

  async saveBulk(type: MetadataType, metadata: any[]) {
    return this.http.post(environment.app.apiUrl + 'metadata/save/' + type, metadata).toPromise();
  }

  async delete(...id: string[]) {
    return this.http.post(environment.app.apiUrl + 'metadata/delete', id).toPromise();
  }

  async process(...id: string[]) {
    return this.http.post(environment.app.apiUrl + 'metadata/process', id).toPromise();
  }

  async repair(payload: any) {
    return this.http.post(environment.app.apiUrl + 'metadata/repair', payload).toPromise();
  }

  async getSamples(jobTitles: string[], limit = 50) {
    return this.http.post<{ userTotal: number, jobTotal: number, users: any[], jobs: any[] }>(environment.app.apiUrl + 'metadata/samples/' + limit, jobTitles).toPromise();
  }

  async getSkills(minConnections: number) {
    return this.http.get<{ [key: string]: number }>(environment.app.apiUrl + 'metadata/skills/' + minConnections).toPromise();
  }
}
